"use strict";
/**
 * customMonitor Module
 *
 * Description 部门稿库管理
 * Author:zhang.yingyu 2018-11-14
 */
angular.module('departmentManuModule', []).
controller('departmentManuController', ['$scope', '$state', '$timeout', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'trsGroupTreeLocationService', function($scope, $state, $timeout, treeService, trsHttpService, modalDialog, trsspliceString, trsGroupTreeLocationService) {

}]);
